import { startApplication } from "@/config/start-application";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Application root is missing");
void startApplication(root);
